import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BusinessGroupedModel } from '@features/business/models/business.model';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { BusinessLogo } from "@shared/components/business-logo/business-logo";

export interface UserFilterModel {
  searchText?: string;
  selectedBusinessGroups?: string[];
}

@Component({
  selector: 'app-user-filter',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    MultiSelectModule,
    ButtonModule,
    BusinessLogo
],
  templateUrl: './user-filter.html',
  styleUrl: './user-filter.scss',
})
export class UserFilter {
  businessGroupOptions = input<BusinessGroupedModel[]>([]);
  loading = input<boolean>(false);

  filterChange = output<UserFilterModel>();
  clearFilters = output<void>();

  searchText: string = '';
  selectedBusinessGroups: string[] = [];

  handleFilter() {
    const filterValues: UserFilterModel = {
      searchText: this.searchText.trim() || undefined,
      selectedBusinessGroups: this.selectedBusinessGroups?.length > 0 ? this.selectedBusinessGroups : undefined,
    };

    // Emitir los valores al componente padre
    this.filterChange.emit(filterValues);
  }

  handleClear(): void {
    this.searchText = '';
    this.selectedBusinessGroups = [];
    this.clearFilters.emit();
  }

  getBusinessGroupOptions() {
    return this.businessGroupOptions().map(group => ({
      label: group.Name,
      value: group.Id,
      logoUrl: group.LogoUrl
    }));
  }
}
